module.exports = __webpack_public_path__ + "static/media/play-circle.38632ac1.svg";